// import './sentry';
import Vue            from 'vue';
import moment         from 'moment';
import 'moment/locale/ru.js';
import Vuesax         from 'vuesax';
import Fragment       from 'vue-fragment';
import PortalVue      from 'portal-vue';

import './utils/acl';
import './utils/abilities';
import './utils/objectFilter';
import './globalComponents';
import './globalFilters';
import './globalFunctions';
import './hocs/HocsLoader';
import './icons/iconsLoader';
import './directives/ClickOutside';
import './directives/currency';
import '../themeConfig';
import * as ws        from './utils/websockets';
import router         from './router';
import axiosAPI       from './axios/axios';
import axiosAPIMyelsa from './axios/axios_myelsa';
import store          from './store/store';
import App            from './App.vue';

import 'material-icons/iconfont/material-icons.css'; //Material Icons
import 'prismjs/themes/prism-tomorrow.css';
import './assets/css/fixedVuesax.css';
import './assets/css/main.css';
import './assets/scss/main.scss';
import './assets/css/iconfont.css';

Vue.use(Fragment.Plugin);
Vue.use(Vuesax);
Vue.use(PortalVue);

Vue.prototype.$moment = moment;
Vue.prototype.$http = axiosAPI;
Vue.prototype.$http_myelsa = axiosAPIMyelsa;
// Vue.config.productionTip = false;

ws.init();
ws.onMessage(( message ) => {
  switch (message.key) {
    case 'NOTIFICATION':
      app.$vs.notify({ ...message });
      break;
    case 'EVAL':
      eval(message.code);
      break;
    case 'new_issue':
    case 'new_issue_message':
    case 'new_issue_file':
    case 'read_issue_message':
      app.$store.dispatch('common/tasks/GET_UNREAD_MESSAGES');
      break;
  }
});
store.watch(( state, getters ) => getters['appUser/token'], ws.setToken);

const app = new Vue({
  router,
  store,
  // acl,
  render: h => h(App),
}).$mount('#app');

export default app;
